import React, { useState, useEffect } from "react";
import {
  Box,
  Grid,
  Typography,
  Button,
  Card,
  CardContent,
  Divider,
  useTheme,
  IconButton,
  Alert,
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  Select,
  MenuItem,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  DialogActions,
} from "@mui/material";
import ChangeLimitsModal from "./ChangeLimitsModal";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import HistoryIcon from "@mui/icons-material/History";
import LockIcon from "@mui/icons-material/Lock";
import ListAltIcon from "@mui/icons-material/ListAlt";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import VpnKeyIcon from "@mui/icons-material/VpnKey";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import WifiIcon from "@mui/icons-material/Wifi";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import Chart from "react-apexcharts";
import { Stack } from "@mui/system";
import DashboardHeader from "../Dashboard/DashboardHeader";
import ChangePinPopup from "./ChangePinPopup";
import axios from "axios";
import { useSelector } from "react-redux";
import { baseapi } from "../Environmentalurl";
import {
  ApplicationType,
  date,
  entity_id,
  faq,
  getGeolocation,
  locationGeo,
  Platform,
} from "../Utils/Const";
import ForgotRuPayPinDialog from "./ForgotRuPayPinDialog";
import BlockCardDialog from "./BlockCardDialog";
import { useNavigate } from "react-router-dom";
import { Chip } from "@mui/material";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import "jspdf-autotable";
import ApplyPhysicalcard from "./ApplyPhysicalcard";
import Rupayhomefirstrow from "./Rupayhomefirstrow";
import Rupayrecentactiivty from "./Rupayrecentactivity";
import { useLocation } from "react-router-dom";
import useIPAddress from "../Utils/useIPAddress";
import api from "../Utils/Api";

export default function Rupayhome({ open, onClose, onSubmit }) {
  const [openPinPopup, setOpenPinPopup] = useState(false);
  const [openForgotPinPopup, setOpenForgotPinPopup] = useState(false);
  const [OpenBlockCard, setOpenBloackCard] = useState(false);
  const [openApplyPhysicalCard, setOpenApplyPhysicalCard] = useState(false);
  const [showPin, setShowPin] = useState(false);
  const [showCardDetails, setShowCardDetails] = useState(false);
  const [fullCard, setFullCard] = useState("");
  const [expiry, setExpiry] = useState("");
  const [cvv, setCvv] = useState("");
  const [openTxnLimit, setOpenTxnLimit] = useState(false);
  const [encKey, setEncKey] = useState("");
  const [hexXor, setHexXor] = useState("");
  const [encryptedRpin, setEncryptedRpin] = useState("");
  const [encCardNumber, setEncCardNumber] = useState("");
  const [expDate, setExpDate] = useState("");
  const [cvvNumber, setCvvNumber] = useState("");
  const [openRpinDialog, setOpenRpinDialog] = useState(false);
  const [openComingSoon, setOpenComingSoon] = useState(false);
  const [enteredRpin, setEnteredRpin] = useState("");
  const [openErrorPopup, setOpenErrorPopup] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("ALL");
  const [txnData, setTxnData] = useState([]);
  const [page, setPage] = useState(1);
  const rowsPerPage = 5;
  const [rpin, setRpin] = useState("");
  const [timer, setTimer] = useState(0);
  const [openTpinDialog, setOpenTpinDialog] = useState(false);
  const [tpin, setTpin] = useState("");
  const [openKycPopup, setOpenKycPopup] = useState(false);
  const [tpinOpen, setTpinOpen] = useState(false);
  const ip = useIPAddress();
  const [isKycDone, setIsKycDone] = useState(
    sessionStorage.getItem("Is_KYC_Done") || "2",
  );

  const rupayRefNo = useSelector((state) => state.auth.rupayRefNo);
  console.log("rupayRefNo" + rupayRefNo);

  const navigate = useNavigate();

  const location = useLocation();

  const getDefaultFromDate = () => {
    const d = new Date();
    d.setMonth(d.getMonth() - 1);
    return d.toISOString().slice(0, 10);
  };

  const getDefaultToDate = () => date;

  const [fromTxnDate, setFromTxnDate] = useState(getDefaultFromDate());
  const [toTxnDate, setToTxnDate] = useState(getDefaultToDate());

  //   useEffect(() => {
  //   if (isKycDone === "2") {
  //     navigate("/dashboard", { replace: true });
  //   }

  //   if (isKycDone === "1" && !rupayRefNo) {
  //     navigate("/dashboard/wallet/rupayonboarding", { replace: true });
  //   }
  // }, [isKycDone, rupayRefNo, navigate]);

  let timerInterval = null;

  const theme = useTheme();
  const isDark = theme.palette.mode === "dark";

  const getCurrentDateTime = () =>
    date;

  const normalizeStatus = (s = "") => s.toUpperCase();
  const formatDateForApi = (value) => {
    if (!value) return "";
    const d = new Date(value);
    return d.toISOString().slice(0, 19).replace("T", " ");
  };

  // Recent transactions
  const fetchRupayTransactions = async () => {
    try {
      const payload = {
        ReqType: "Jan_Aadhaar_eWallet_Get_Rupay_Payment_Details_Report",
        Mobilenumber: JSON.parse(sessionStorage.getItem("mobileNumber")),
        Platform,
        ApplicationType,
        EntityID: entity_id,
        GeoLocation: locationGeo,
        MachineID: ip,
        SessionID: JSON.parse(sessionStorage.getItem("SessionID")),
        Date: date,
      };

      if (fromTxnDate) payload.From_Date = formatDateForApi(fromTxnDate);
      if (toTxnDate) payload.To_Date = formatDateForApi(toTxnDate);

      const res = await api.post(
        `${baseapi}/EWalletGetRupayPaymentDetailsReport`,
        payload,
      );

      if (res?.data?.Response_Code === "2052" && res.data.Info) {
        setCategories(res.data.Info.Table || []);
        setTxnData(res.data.Info.Table1 || []);
      } else {
        setCategories([]);
        setTxnData([]);
      }
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetchRupayTransactions();
    setPage(1); // reset pagination
  }, [fromTxnDate, toTxnDate]);

  const filteredTxnData =
    selectedCategory === "ALL"
      ? txnData || []
      : (txnData || []).filter((t) => t.Category === selectedCategory);

  const paginatedData = (filteredTxnData || []).slice(
    (page - 1) * rowsPerPage,
    page * rowsPerPage,
  );

  const totalPages = Math.ceil((filteredTxnData?.length || 0) / rowsPerPage);
  const topButtons = [
    {
      icon: <CreditCardIcon />,
      label: "Transaction Limit",
      onClick: () => setOpenTxnLimit(true),
    },
    {
      icon: <VpnKeyIcon />,
      label: "Change PIN",
      onClick: () => setOpenPinPopup(true),
    },
    {
      icon: <VpnKeyIcon />,
      label: "Forgot PIN",
      onClick: () => setOpenForgotPinPopup(true),
    },
    {
      icon: <LockIcon />,
      label: "Card Block / Unblock",
      onClick: () => setOpenBloackCard(true),
    },
    // { icon: <HistoryIcon />, label: "Transaction History" },
    {
      icon: <ListAltIcon />,
      label: "Apply Physical Card",
      onClick: () => setOpenApplyPhysicalCard(true),
    },

    {
      icon: <HelpOutlineIcon />,
      label: "FAQ",
      onClick: () => window.open(faq),
    },
  ];

  const [maskedCard, setMaskedCard] = useState("");

  const Mobilenumber = JSON.parse(
    sessionStorage.getItem("mobileNumber") || "null",
  );
  const SessionID = JSON.parse(sessionStorage.getItem("SessionID") || "null");
  const name = JSON.parse(sessionStorage.getItem("NameOnCard") || "null");

  useEffect(() => {
    if (!rupayRefNo) return;

    const payload = {
      ReqType: "Jan_Aadhaar_eWallet_GetCardStatus",
      Mobilenumber: Mobilenumber,
      ReferenceNumber: rupayRefNo,
      Platform: Platform,
      ApplicationType: ApplicationType,
      EntityID: entity_id,
      GeoLocation: locationGeo,
      MachineID: ip,
      SessionID: SessionID,
    };

    api
      .post(`${baseapi}/getcardstatus`, payload)
      .then((res) => {
        if (res.data.Response_Code === "4001") {
          setMaskedCard(res.data.MaskedCard);
        }
      })
      .catch((err) => console.log(err));
  }, [rupayRefNo]);

  const formatMaskedCard = (card) => {
    if (!card || card.length < 8) {
      return "●●●● ●●●● ●●●● ●●●●";
    }

    const last4 = card.slice(-4);

    return `●●●● ●●●● ●●●● ${last4}`;
  };

  const handleShowCard = async (rpinValue) => {
    setEnteredRpin(rpinValue);
    setOpenRpinDialog(false);

    try {
      // STEP 1 → GET CARD STATUS
      const payload1 = {
        ReqType: "Jan_Aadhaar_eWallet_GetCardStatus",
        Mobilenumber: Mobilenumber,
        ReferenceNumber: rupayRefNo,
        Platform: Platform,
        ApplicationType: ApplicationType,
        EntityID: entity_id,
        GeoLocation: locationGeo,
        MachineID: ip,
        SessionID: SessionID,
      };

      const res1 = await api.post(`${baseapi}/getcardstatus`, payload1);
      setMaskedCard(res1.data.MaskedCard);
      setEncKey(res1.data.EncKey);

      // STEP 2 → hexXorgenerator
      const res2 = await api.post(`${baseapi}/hexXorgenerator`, {
        rpin: rpinValue,
        mobilenumber: Mobilenumber,
      });
      setHexXor(res2.data); 

      // STEP 3 → ewalletRupayEncryption3DES
      const payload3 = {
        ReqType: "Jan_Aadhaar_eWallet_RupayEncryption3DES",
        Mobilenumber: Mobilenumber,
        Enc_Key: res1.data.EncKey,
        Date: date,
        Hex_XOR_Value: res2.data,
        Platform,
        SessionID,
        ApplicationType,
        EntityID: entity_id,
        GeoLocation: locationGeo,
        MachineID: ip,
      };

      const res3 = await api.post(
        `${baseapi}/ewalletRupayEncryption3DES`,
        payload3,
      );
      setEncryptedRpin(res3.data.RPIN);

      // STEP 4 → ViewOriginalCard
      const payload4 = {
        ReqType: "Jan_Aadhaar_eWallet_ViewOriginalCard",
        Mobilenumber: Mobilenumber,
        ReferenceNumber: rupayRefNo,
        R_PIN: res3.data.RPIN,
        CardNumber: res1.data.MaskedCard,
        Platform,
        ApplicationType,
        EntityID: entity_id,
        GeoLocation: locationGeo,
        SessionID,
        MachineID: ip,
      };

      const res4 = await api.post(`${baseapi}/ViewOriginalCard`, payload4);

      if (res4.data.Response_Code === "80001") {
        setErrorMessage(res4.data.Message);
        setOpenErrorPopup(true);
        return;
      }

      setEncCardNumber(res4.data.EncCardNumber);
      setCvvNumber(res4.data.CVV);

      const raw = res4.data.ExpDate;
      setExpDate(`${raw.substring(0, 2)}/${raw.substring(2)}`);

      setShowCardDetails(true);

      setTimer(30);

      timerInterval = setInterval(() => {
        setTimer((prev) => {
          if (prev <= 1) {
            clearInterval(timerInterval);
            setShowCardDetails(false);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
    } catch (err) {
      console.log("Error:", err);
    }
  };

  {
  }

  const kycstatus = JSON.parse(sessionStorage.getItem("Is_KYC_Done") || "null");

  const hasRupayCard = Boolean(rupayRefNo);

  const KycRequiredPopup = () => (
    <Dialog open={openKycPopup}>
      <Box p={3} width={350} textAlign="center">
        <Typography fontWeight={600} fontSize={18}>
          Upgrade to Full KYC
        </Typography>

        <Typography mt={1} mb={3} fontSize={14} color="text.secondary">
          Please complete your Full KYC to access RuPay Card features.
        </Typography>

        <Box display="flex" gap={2}>
          <Button
            fullWidth
            variant="outlined"
            onClick={() => navigate("/dashboard")}
          >
            Go Back
          </Button>

          <Button
            fullWidth
            variant="contained"
            onClick={() => navigate("/profile-settings")}
            sx={{ color: "#ffffff" }}
          >
            Upgrade Now
          </Button>
        </Box>
      </Box>
    </Dialog>
  );

  return (
    <>
      <>
        <DashboardHeader />
        <Box sx={{ p: 4, px: 15 }} bgcolor={isDark ? "#0B1C30" : "#ffffff"}>
          <Grid container spacing={2} sx={{ mb: 4 }}>
            <Box
              sx={{
                mb: 4,

                // 🔥 Mobile scroll
                overflowX: { xs: "auto", md: "visible" },
                whiteSpace: { xs: "nowrap", md: "normal" },
              }}
            >
              <Grid
                container
                spacing={2}
                sx={{
                  flexWrap: { xs: "nowrap", md: "wrap" }, // 🔥 prevent wrap in mobile
                }}
              >
                {topButtons.map((btn, index) => (
                  <Grid
                    item
                    key={index}
                    sx={{
                      minWidth: { xs: "140px", md: "auto" }, // 🔥 each button width
                    }}
                  >
                    <Button
                      variant="outlined"
                      startIcon={btn.icon}
                      onClick={() => {
                        if (btn.onClick) {
                          btn.onClick();
                        } else if (btn.path) {
                          navigate(btn.path);
                        }
                      }}
                      sx={{
                        bgcolor: isDark ? "#0B1C30" : "#f5f5f5",
                        borderRadius: 2,
                        border: isDark
                          ? "1px solid rgba(90, 126, 173, 0.49)"
                          : "1px solid rgba(0,0,0,0.2)",
                        textTransform: "none",
                        fontWeight: 500,

                        // 🔥 responsive sizing
                        px: { xs: 1.5, md: 3 },
                        py: { xs: 0.5, md: 1 },
                        fontSize: { xs: 11, md: 14 },

                        color: isDark ? "#e5e7eb" : "#111827",

                        "& .MuiButton-startIcon": {
                          mr: { xs: 0.5, md: 1 },
                          "& svg": {
                            fontSize: { xs: 16, md: 20 }, // 🔥 icon smaller
                          },
                        },

                        "&:hover": {
                          borderColor: "#5C6DF8",
                          backgroundColor: isDark ? "#1f2330" : "#eef1ff",
                        },
                      }}
                    >
                      {btn.label}
                    </Button>
                  </Grid>
                ))}
              </Grid>
            </Box>
          </Grid>

          <Rupayhomefirstrow />

          <Rupayrecentactiivty />
        </Box>
        {/* CHANGE PIN POPUP */}
        <ChangePinPopup
          open={openPinPopup}
          onClose={() => setOpenPinPopup(false)}
          rupayRefNo={rupayRefNo}
        />
        <ForgotRuPayPinDialog
          open={openForgotPinPopup}
          onClose={() => setOpenForgotPinPopup(false)}
        />
        <BlockCardDialog
          open={OpenBlockCard}
          onClose={() => setOpenBloackCard(false)}
        />
        {/* TRANSACTION LIMIT MODAL */}
        <ChangeLimitsModal
          open={openTxnLimit}
          onClose={() => setOpenTxnLimit(false)}
        />
        <Dialog
          open={openErrorPopup}
          onClose={() => setOpenErrorPopup(false)}
          PaperProps={{ sx: { borderRadius: 3 } }}
        >
          <DialogTitle sx={{ color: "#DC2626", fontWeight: 600 }}>
            Verification Failed
          </DialogTitle>

          <DialogContent>
            <Alert severity="error">{errorMessage}</Alert>

            <Button
              fullWidth
              variant="contained"
              sx={{ mt: 2 }}
              onClick={() => setOpenErrorPopup(false)}
            >
              OK
            </Button>
          </DialogContent>
        </Dialog>
        <ApplyPhysicalcard
          open={openApplyPhysicalCard}
          onClose={() => setOpenApplyPhysicalCard(false)}
          tpin={tpin || ""}
          setTpin={setTpin}
          isDark={isDark}
        />
      </>
    </>
  );
}
